import NZContact from "../../../components/NZComponent/home/NZContact/NZContact";
import PETROLSIDE from "../../../assets/png/PETROLSIDE.png";
import { useNavigate } from "react-router";
import PETROLModels from "../../../components/NZComponent/NzPetrol/PETROLModels";
import HighLevelSpecs from "../../../components/NZComponent/NzPetrol/HighLevelSpecs";
import NZNZPetrolGregFarrier from "../../../components/NZComponent/NzPetrol/NZNZPetrolGregFarrier";
import NZElectricaTV from "../../../components/NZComponent/NzPetrol/NZElectricaTV";
import HomeIcon from "../../../assets/svg/HomeIcon.svg";
import RightSideArrow from "../../../assets/svg/RightSideArrow.svg";
import NZGregFarrier from "../../../components/NZComponent/home/NZGregFarrier/NZGregFarrier";
import NZGregAssociates from "../../../components/NZComponent/home/NZGregAssociates/NZGregAssociates";
import Gallary_One from "../../../assets/images/Gallary/Gallary_One.png";
import Gallary_Two from "../../../assets/images/Gallary/Gallary_Two.png";
import Gallary_Three from "../../../assets/images/Gallary/Gallary_Three.png";
import Gallary_Four from "../../../assets/images/Gallary/Gallary_Four.png";
import Gallary_Fifth from "../../../assets/images/Gallary/Gallary_Fifth.png";
import Gallary_Six from "../../../assets/images/Gallary/Gallary_Six.png";
import Gallary_Seventh from "../../../assets/images/Gallary/Gallary_Seventh.png";
import Gallary_Eighth from "../../../assets/images/Gallary/Gallary_Eighth.png";
import Gallary_Nine from "../../../assets/images/Gallary/Gallary_Nine.png";
import Gallary_Ten from "../../../assets/images/Gallary/Gallary_Ten.png";
import Gallary_Eleven from "../../../assets/images/Gallary/Gallary_Eleven.png";
import Gallary_twelve from "../../../assets/images/Gallary/Gallary_twelve.png";
import CardUpImg from "../../../assets/svg/nz-bg-card-up-white.svg";
const NZGallery = () => {
  let navigate = useNavigate();
  return (
    <>
      <div>
        <div className="px-[12px] py-[6px] bg-[#F0F0F0] flex items-center">
          <img src={HomeIcon} alt="HomeIcon" className="cursor-pointer" onClick={() => navigate("/")} />
          <div className="flex items-center mx-[5px]">
            <img src={RightSideArrow} alt="RightSideArrow" />
            <img src={RightSideArrow} alt="RightSideArrow" />
          </div>
          <div className="text-[14px] leading-[24px] text-[#383838] montserrat-semi-bold">{`Gallery`}</div>
        </div>
        <div className="w-full bg-fixed bg-cover bg-center">
          {" "}
          <div className="w-full flex items-center justify-center">
            <div
              className="text-white kuunari-bold 
                      text-[40px] 
                      md:text-[80px] 
                      lg:text-[120px]  py-[68px] max-w-[1127px] text-center"
              style={{
                textShadow: "2px 4px 6px #000000",
              }}
            >
              Gallery
            </div>
          </div>
          <img src={CardUpImg} className="w-full" />
        </div>
        <div className="bg-white pt-[60px] pb-[45px]">
          <div className="custom-container px-[30px] text-start mx-auto ">
            <div className="max-w-[1200px]  mx-auto">
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-4 gap-5 max-w-[1400px] mx-auto">
                <img src={Gallary_One} alt="1" className="w-full h-[260px] object-cover" />
                <img src={Gallary_Two} alt="" className="w-full h-[260px] object-cover" />
                <img src={Gallary_Three} alt="" className="w-full h-[260px] object-cover" />
                <img src={Gallary_Four} alt="" className="w-full h-[260px] object-cover" />
                <img src={Gallary_Fifth} alt="" className="w-full h-[260px] object-cover" />
                <img src={Gallary_Six} alt="" className="w-full h-[260px] object-cover" />
                <img src={Gallary_Seventh} alt="" className="w-full h-[260px] object-cover" />
                <img src={Gallary_Eighth} alt="" className="w-full h-[260px] object-cover" />
                <img src={Gallary_Nine} alt="" className="w-full h-[260px] object-cover" />
                <img src={Gallary_Ten} alt="" className="w-full h-[260px] object-cover" />
                <img src={Gallary_Eleven} alt="" className="w-full h-[260px] object-cover" />
                <img src={Gallary_twelve} alt="" className="w-full h-[260px] object-cover" />
              </div>
            </div>
          </div>
        </div>
        <NZGregFarrier
          bg={"#fff"}
          slogan="“THIS IS HANDS DOWN THE MOST VERSATILE ATV I HAVE PURCHASED FOR THE FARM.”"
        />
        <div id="contact-form">
          <NZContact />
        </div>
        {/* <NZGregAssociates /> */}
      </div>
    </>
  );
};
export default NZGallery;
